import { render, staticRenderFns } from "./auto-subscription.vue?vue&type=template&id=118560df&scoped=true"
import script from "./auto-subscription.vue?vue&type=script&lang=js"
export * from "./auto-subscription.vue?vue&type=script&lang=js"
import style0 from "./auto-subscription.vue?vue&type=style&index=0&id=118560df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118560df",
  null
  
)

export default component.exports